module.exports = __webpack_public_path__ + "media/images/athletes/1766-35a2399828fd38ed747d7472a4158420.png";